import React from "react";

const ClientBadge = ({ clientId, className = "", partner = false }) => {
  const clientId_i = parseInt(clientId);

  if (partner) {
    return (
      <span
        className={`badge ${className}`}
        style={{
          backgroundColor: "#6c757d",
          color: "#fff",
          fontStyle: "italic",
        }}>
        Partner
      </span>
    );
  }

  switch (clientId_i) {
    case 10:
      return <span className={`badge badge-success ${className}`}>KV</span>;
    case 11:
      return <span className={`badge badge-primary ${className}`}>DC</span>;
    case 29:
      return <span className={`badge badge-warning ${className}`}>AP</span>;
    case 54:
      return <span className={`badge badge-info ${className}`}>DV</span>;
    case 69:
      return <span className={`badge badge-danger ${className}`}>VM</span>;
    case 61:
      return (
        <span
          className={`badge badge-danger ${className}`}
          style={{ backgroundColor: "lightblue" }}>
          VIS
        </span>
      );
    case 120:
      return (
        <span
          className={`badge badge-danger ${className}`}
          style={{ backgroundColor: "lightgreen" }}>
          VV
        </span>
      );
    default:
      return <span className={`badge ${className}`}>?</span>;
  }
};

export default ClientBadge;
